import React, { useRef, useState } from "react";
import { Button } from "antd";
import { PauseOutlined, PlayCircleOutlined } from "@ant-design/icons";

interface Props {
  src?: string;
  size?: "small" | "middle" | "large";
}

const AudioPlayButton: React.FC<Props> = ({ src, size = "small" }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  if (!src) return null;

  const toggle = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(src);
      audioRef.current.addEventListener("ended", () => setPlaying(false));
    }
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
    } else {
      audioRef.current.play();
      setPlaying(true);
    }
  };

  return (
    <Button
      type="text"
      size={size}
      icon={playing ? <PauseOutlined /> : <PlayCircleOutlined />}
      onClick={toggle}
    />
  );
};

export default AudioPlayButton;
